import CommisionRates from "./commissionRates"

export default CommisionRates
